/** Money as people write it and as the ficha and the board show it. Stored in cents everywhere. */

/** Whole reais stay whole ("R$ 390"); anything with centavos shows both digits ("R$ 390,50"). */
export const money = (cents: number | null) =>
  cents === null ? null
    : `R$ ${(cents / 100).toLocaleString("pt-BR", { minimumFractionDigits: cents % 100 ? 2 : 0 })}`;

/** For an input: "390,00", or empty. */
export const formatReais = (cents: number | null) =>
  cents === null ? "" : (cents / 100).toLocaleString("pt-BR", { minimumFractionDigits: 2 });

/**
 * Money is typed the way people write it — "390", "390,50", "1.200" — and stored in cents.
 * The old form asked for centavos ("R$ 390,00 são 39000"), which nobody should have to compute.
 */
export function parseReais(text: string): number | null {
  const clean = text.trim().replace(/[R$\s]/g, "");
  if (!clean) return null;
  const normalised = /,\d{1,2}$/.test(clean)
    ? clean.replace(/\./g, "").replace(",", ".")
    : clean.replace(/,/g, "");
  const value = Number(normalised);
  return Number.isFinite(value) && value >= 0 ? Math.round(value * 100) : null;
}
